import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CTAButton from '../../../CTAButton';
import { setStep } from '../redux/action';

const Step6 = () => {
  const dispatch = useDispatch();
  const metadata = useSelector(state => state.metadata);

  return (
    <div>
      <h4>
        Based on the information you have provided your warranty claim number has been established,
        we just need a few more details to complete your claim and begin our evaluation
      </h4>
      <p>
        Your Claim Number is:{' '}
        <strong>#{metadata?.pqsResponse?.claim_number}</strong>
      </p>

      <p>The following items may be needed to evaluate your claim:</p>

      <ul>
        <li>Proof of Ownership</li>
        <li>Proof of Purchase</li>
        <li>Photos of the affected area(s)</li>
        <li>A physical shingle sample</li>
      </ul>

      <CTAButton
        onClick={() => dispatch(setStep(7))}
        data-track="form-advance"
        data-track-form-name="Submit Claim"
        data-track-form-step="step 6 - gather additional information"
        element="button"
        text="Click here to Continue"
        type="submit"
      />
    </div>
  );
};

export default Step6;
